



































































































































































































import {Component, Vue} from "vue-property-decorator";
import breadcrumb from "@/components/common/breadcrumb.vue";
import {getEditItemList, getConfig, autoPut, getStatusByItemIds} from '@/services/api'
import store from "@/store";
import {Message} from "element-ui";

@Component({
  components: {'zf-breadcrumb': breadcrumb},
})
export default class EditList extends Vue {
  // 控制列表高度
  public tableHeight = window.innerHeight - 220;
  // 地区列表
  public countryList: {code: string, name: string}[] = [];
  // 投手列表
  public createrList: {code: string, name: string}[] = [];
  // 日期
  public date: string[] = [];
  // 上传表单
  public formData: {
    country?: string,
    title?: string,
    language?: string,
    itemId?: number,
    tempLinkUrl?: string,
    creater?: string,
    startDate?: string,
    endDate?: string,
    currency?: string,
    tspuIds?: string,
    pageNo: number,
    pageSize: number
  } = {
    pageNo: 1,
    pageSize: 20
  };
  // 列表总数
  public totalNum = 0;
  // 列表数据
  public tableData: {
    title: string,
    itemId: number,
    linkUrl: string,
    firstCover: string,
    creater: string,
    createTime: number,
    createTimeStr: string,
    price: number,
    currency: string,
    pageNo: number,
    pageSize: number,
    tspuIds: string,
    tspuIdList: string[],
    asset: string,
    assetBody: string,
    assetTitle: string,
    autoPutChecked: boolean,
    autoPutStatus: string,
  }[] = [];

  public dialogVisible = false;
  public copyData: {copyItemId?: number, country?: string} = {};

  public pickerOptions = {
    shortcuts: [{
      text: '最近一周',
      onClick(picker: any) {
        const end = new Date(), start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近一个月',
      onClick(picker: any) {
        const end = new Date(), start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近三个月',
      onClick(picker: any) {
        const end = new Date(), start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit('pick', [start, end]);
      }
    }]
  };

  get autoPutNum(): number {
    return this.tableData.filter(item => item.autoPutChecked).length
  }

  get autoPutedNum(): number {
    return this.tableData.filter(item => item.autoPutStatus).length
  }

  get cantAutoPutNum(): number {
    return this.tableData.filter(item => !item.asset).length
  }

  /**
   * 初始化方法
   */
  async created(): Promise<void> {
    window.onresize = () => {
      try {
        this.tableHeight = window.innerHeight - 220;
      } catch (e) {}
    }
    await this.getEditItemList();
    this.getConfig();
  }

  /**
   * 获取item列表
   */
  async getEditItemList(): Promise<void> {
    try{
      this.formData.startDate = this.date && this.date[0];
      this.formData.endDate = this.date && this.date[1];
      const res = await getEditItemList(this.formData, true)
      if (res.data && res.data.status === 'OK') {
        this.tableData = res.data.result.results || [];
        this.totalNum =  res.data.result.totalNum || 0;
        for (let item of this.tableData) {
          item.tspuIdList = item.tspuIds? item.tspuIds.split(';') : [];
        }
        await this.getStatusByItemIds();
      }
    } catch (e) {}
  }

  /**
   * 自动投放查询
   */
  async getStatusByItemIds(): Promise<void>  {
    if (this.tableData.length === 0) {
      return;
    }
    const res2 = await getStatusByItemIds({ids: this.tableData.map(item => item.itemId)})
    for (let item of this.tableData) {
      for (let itemInfo of res2.data.result) {
        if (item.itemId === itemInfo.itemId) {
          item.autoPutStatus = itemInfo.status;
        }
        Vue.set(item, 'autoPutChecked', false)
      }
    }
  }

  /**
   * 获取字典信息
   */
  getConfig(): void {
    if (!this.$store.state.region || this.$store.state.region.length === 0) {
      getConfig({type: 'region'}).then(res => {
        if (res.data && res.data.status === 'OK') {
          this.countryList = res.data.result || [];
          store.commit('SET_REGION', this.countryList);
        }
      })
    } else {
      this.countryList = this.$store.state.region;
    }
    if (!this.$store.state.toushou || this.$store.state.toushou.length === 0) {
      getConfig({type: 'toushou'}).then(res => {
        if (res.data && res.data.status === 'OK') {
          this.createrList = res.data.result || [];
          store.commit('SET_TOUSHOU', this.createrList);
        }
      })
    } else {
      this.createrList = this.$store.state.toushou;
    }
  }

  /**
   * 编辑
   * @param i 索引
   * @param e 当前item
   */
  edit(i: number, e: any): void {
    window.open('/edit/modify/' + e.itemId,'_blank')
  }

  /**
   * 复制
   * @param i 索引
   * @param e 当前item
   */
  copy(i: number, e: any): void {
    this.copyData = {copyItemId: e.itemId, country: ''}
    this.dialogVisible = true;
  }

  handleCopy(): void {
    if (this.copyData.country && this.copyData.copyItemId) {
      window.open(`/edit/copy/${this.copyData.copyItemId}/${this.copyData.country}`, '_blank')
    }
  }

  handleClose(): void {
    this.dialogVisible = false;
  }

  /**
   * 查询
   */
  search(): void {
    this.formData.pageNo = 1;
    this.getEditItemList();
  }

  /**
   * 分页大小变化
   * @param val
   */
  handleSizeChange(val: number): void {
    this.formData.pageSize = val;
    this.formData.pageNo = 1;
    this.getEditItemList();
  }

  /**
   * 当前页面变化
   * @param val
   */
  handleCurrentChange(val: number): void {
    this.formData.pageNo = val;
    this.getEditItemList();
  }

  /**
   * 打开新链接图片
   * @param url
   */
  openImg(url: string): void {
    window.open(url, '_blank');
  }

  /**
   * 自动投放选择变化钩子
   * @param selectedList
   */
  async autoPut(selectedList: any[]) {
    try {
      await this.$confirm('确定一键投放吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
      const params = this.tableData
        .filter(item => item.autoPutChecked && !item.autoPutStatus)
        .map(item => ({"itemId": item.itemId}))
      const res = await autoPut(params);
      if (res.status === 200) {
        await Message.success('投放成功！')
      }
      await this.getStatusByItemIds();

    } catch (e) {}
  }

  /**
   * 全选
   * @param status
   */
  selectAll(status: boolean) {
    for (let item of this.tableData) {
      if (!item.autoPutStatus && item.asset) {
        Vue.set(item, 'autoPutChecked', !status)
      }
    }
  }
}

